import { MenuConfigurationDTO, MenuGroupConfigurationDTO } from 'core/api';

export function selectMenu(configuration: MenuConfigurationDTO): MenuConfigurationDTO {
	return {
		...configuration,
		MenuGroups: []
	};
}

export function addOrRemoveGroup(currentConfiguration: MenuConfigurationDTO, group: MenuGroupConfigurationDTO): MenuConfigurationDTO {

	const newSelection = { ...currentConfiguration };
	const exists = newSelection.MenuGroups.find(x => x.GroupName === group.GroupName);

	if (exists)
		return { ...currentConfiguration, MenuGroups: currentConfiguration.MenuGroups.filter(x => x.GroupName !== group.GroupName) };

	return { ...currentConfiguration, MenuGroups: [...currentConfiguration.MenuGroups, group] };
}